import loc from 'owa-localize';
import { EntityType } from '@augloop-types/honeybee';
import {
    SonoraIntroHintTextForFiles,
    SonoraIntroHintTextForMeetingTimes,
} from './SonoraHints.locstring.json';

export function getIntentDetectionHintNodeText(
    type: EntityType | undefined,
    triggerCharacter: string
): string {
    switch (type) {
        case EntityType.File:
            return loc(SonoraIntroHintTextForFiles);
        case EntityType.MeetingAvailability:
            return loc(SonoraIntroHintTextForMeetingTimes, `"${triggerCharacter}free"`);
        default:
            return '';
    }
}

export function getIntentDetectionTeachingBubbleText(
    type: EntityType | undefined,
    triggerCharacter: string
): string {
    switch (type) {
        case EntityType.File:
            return loc(SonoraIntroHintTextForFiles, `${triggerCharacter}`);
        case EntityType.MeetingAvailability:
            return loc(SonoraIntroHintTextForMeetingTimes, `${triggerCharacter}free`);
        default:
            return '';
    }
}
